// WARN: We avoid exporting the actual regex object, because of the dangers of sharing.
// E.g. With global regex, each execution with the same input, will resume at the place where it left off last time, producing inconsistent results!
export const WORD_REGEX_EXPRESSION = `(\\b[\\w'"]+\\b)`;

/**
 * @returns an array of words from the given text, including their index in the text
 */
export function splitIntoWords(
  text: string,
  includeInBetweenParts = false,
): { wordIndex: number; wordStartsAt: number; word: string }[] {
  const matches = [];
  let match;
  let i = 0;
  let lastWordEndedAt = 0;
  const regex = new RegExp(WORD_REGEX_EXPRESSION, 'gm');
  while ((match = regex.exec(text))) {
    if (includeInBetweenParts) {
      if (lastWordEndedAt < match.index) {
        matches.push({
          wordIndex: i++,
          wordStartsAt: lastWordEndedAt,
          word: text.substring(lastWordEndedAt, match.index),
        });
      }
    }

    matches.push({
      wordIndex: i++,
      wordStartsAt: match.index,
      word: match[0],
    });
    lastWordEndedAt = match.index + match[0].length;
  }

  if (includeInBetweenParts) {
    if (lastWordEndedAt < text.length) {
      matches.push({
        wordIndex: i++,
        wordStartsAt: lastWordEndedAt,
        word: text.substring(lastWordEndedAt),
      });
    }
  }
  return matches;
}

export function countWords(text: string): number {
  const regex = new RegExp(WORD_REGEX_EXPRESSION, 'gm');
  return text?.match(regex)?.length;
}

/**
 * @returns an array of lines from the given text, including the index of the line's first character in the text
 */
export function splitIntoLines(
  text: string,
): { lineIndex: number; lineStartsAt: number; line: string }[] {
  const lineRegex = /([^\r\n]+)/gm;
  const matches = [];
  let match;
  let i = 0;
  while ((match = lineRegex.exec(text))) {
    matches.push({
      lineIndex: i++,
      lineStartsAt: match.index,
      line: match[0],
    });
  }
  return matches;
}
